<template>
  <div class="home">
    <div class="head-title">代理商业绩</div>
    <div class="">
      <div class="">
        <div class="tianjia">
          <el-table
            :data="tableData.data"
            row-key="id"
            border
            :tree-props="{ children: 'children', hasChildren: 'hasChildren' }"
          >
            <el-table-column
              prop="account"
              label="账号"
              style="width: 20%"
            ></el-table-column>
            <el-table-column
              prop="province"
              label="省"
              style="width: 10%"
            ></el-table-column>
            <el-table-column
              prop="city"
              label="城市"
              style="width: 10%"
            ></el-table-column>
            <el-table-column
              prop="phoneTwo"
              label="备用电话"
              style="width: 20%"
            ></el-table-column>
            <el-table-column
              prop="enterpriseName"
              label="营业名称"
              style="width: 10%"
            ></el-table-column>
            <el-table-column
              prop="levelName"
              label="代理商等级"
              style="width: 10%"
            ></el-table-column>
            <el-table-column
              prop="enterprisePhoto"
              label="营业执照"
              style="width: 10%"
            >
              <template slot-scope="scope">
                <el-image
                  style="width: 7.0rem; height: 7.0rem"
                  :src="scope.row.enterprisePhoto"
                  :preview-src-list="[scope.row.enterprisePhoto]"
                  fit="scale-down"
                ></el-image>
              </template>
            </el-table-column>
            <el-table-column fixed="right" label="操作" style="width: 10%">
              <template slot-scope="scope">
                <el-button
                  type="primary"
                  @click="(zhiyuan = true), fp(scope.row.id)"
                  size="mini"
                  >查看业绩</el-button
                >
              </template>
            </el-table-column>
          </el-table>
          <div class="paging">
            <pagination
              :total="tableData.total"
              :page.sync="listQuery.page"
              :limit.sync="listQuery.limit"
              :page-sizes="[10,20,50,100]"
              @pagination="getData"
            />
          </div>
        </div>
        <el-dialog title="业绩" center :visible.sync="zhiyuan" width="69.4%">
          <el-table :data="xinxi" border style="width:100%;">
            <el-table-column
              property="account"
              label="用户名称"
              width="120"
            ></el-table-column>
            <el-table-column
              property="priveName"
              label="用户权限"
              width="120"
            ></el-table-column>
            <el-table-column
              property="phone"
              label="电话"
              width="150"
            ></el-table-column>
            <el-table-column
              property="province"
              label="省"
              width="100"
            ></el-table-column>
            <el-table-column
              property="city"
              label="城市"
              width="100"
            ></el-table-column>
            <el-table-column
              property="city"
              label="详细地址"
              width="150"
            ></el-table-column>
            <el-table-column
              property="enterpriseName"
              label="企业名称"
              width="200"
            ></el-table-column>
            <el-table-column
              property="enterpriseScale"
              label="企业规模"
              width="150"
            ></el-table-column>
            <el-table-column
              property="enterprisePhoto"
              label="营业执照"
              width="200"
            >
              <template slot-scope="scope">
                <img
                  :src="`${scope.row.enterprisePhoto}`"
                  min-width="200"
                  height="100"
                />
              </template>
            </el-table-column>
          </el-table>
        </el-dialog>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import qs from "qs";
import Vue from "vue";
export default {
  data() {
    return {
      tableData: {
        total: 0,
        data: [],
      },
      url: "https://api.weijub.com/",
      yonghu: "",
      xinxi: [], //用户信息
      zhiyuan: false,
      tooken: "",
      title: {},
      listQuery: {
        page: 1,
        limit: 20,
      },
    };
  },
  mounted() {
    if (window.sessionStorage.getItem("title")) {
      let title = JSON.parse(window.sessionStorage.getItem("title"));
      this.title = title;
      var a = document.title;
      document.title = title[0].website + "-" + a;
    }
    //  获取代理商列表

    if (window.sessionStorage.getItem("userinfone")) {
      let userinfo = JSON.parse(window.sessionStorage.getItem("userinfone"));
      this.tooken = userinfo;
    }
    this.xuanran();
  },
  methods: {
    xuanran() {
      this.axios
        .post(
          "/api/agent/getAgentUser",
          qs.stringify({
            totaltoken: this.tooken.totaltoken,
            page: this.listQuery.page,
            number_page: this.listQuery.limit,
          }),
          { headers: { "Content-Type": "application/x-www-form-urlencoded" } }
        )
        .then((res) => {
          if (res.data.msg == "登录超时") {
            this.$router.push("/Tagent");
          }
          this.tableData = res.data.data;
        })
        .catch(function (err) {});
    },
    //tooken验证

    fp(e) {
      this.yonghu = e;
      this.axios
        .post(
          "/api/agent/agentAccountPrive",
          qs.stringify({
            agent_id: this.yonghu,
            totaltoken: this.tooken.totaltoken,
          }),
          { headers: { "Content-Type": "application/x-www-form-urlencoded" } }
        )
        .then((res) => {
          if (res.data.msg == "登录超时") {
            this.$router.push("/Tagent");
          }
          this.xinxi = res.data.data;
        })
        .catch(function (err) {});
    },
  },
};
</script>
<style scoped>
.home {
  padding: 2rem;
  border-radius: .8rem;
  box-shadow: .3rem .3rem 2rem 0 rgba(0,0,0,0.1);
}
.shouye {
  width: 100%;
  height: 100%;
}
.body_html {
  width: 100%;
  height: 100%;
}
.wei_body {
  width: 100%;
  height: 100%;
  background-color: #ffffff;
  box-shadow: .0rem 1px 6px .0rem rgba(0, 0, 0, 0.2);
  padding: 23px 31px;
  overflow: hidden;
  overflow-y: auto;
}
.tianjia {
  width: 100%;
  height: 100%;
  overflow: hidden;
  overflow-y: auto;
}
.tianjia > main {
  font-size: 26px;
}
.bule {
  width: 100%;
  height: 69px;
  background-color: #2890dd;
  z-index: 10;
  position: absolute;
  top: .0rem;
  left: .0rem;
}
</style>
